/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
import { sha256 } from '@noble/hashes/sha2.js';
import { utf8ToBytes } from '@noble/hashes/utils.js';

const byteToHex: string[] = [];

for (let i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).slice(1));
}

/**
 * Generates a random-ish valid UUID that is deterministically based on the given given
 * base identifiers. The returned IDs are (in practice) collision-free for any unique parameters.
 * @param baseIds array of base identifiers
 * @returns unique v4 UUID based on the parameters
 */
export default function generateDeterministicUuid(baseIds: string[], postfix?: string): string {
  const baseWord = baseIds.join('\n');
  const bytes = sha256(utf8ToBytes(baseWord));
  // Set certain bits to comply UUID v4 specs
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  // The following bytes-to-UUID-string conversion is based on the implementation in the `uuid` library.
  // Convert each byte to a string, concatenating the result, and ensuring that dashes (-) are in their correct positions.
  const uuid = `${byteToHex[bytes[0]]}${byteToHex[bytes[1]]}${byteToHex[bytes[2]]}${byteToHex[bytes[3]]}-${
    byteToHex[bytes[4]]
  }${byteToHex[bytes[5]]}-${byteToHex[bytes[6]]}${byteToHex[bytes[7]]}-${byteToHex[bytes[8]]}${byteToHex[bytes[9]]}-${
    byteToHex[bytes[10]]
  }${byteToHex[bytes[11]]}${byteToHex[bytes[12]]}${byteToHex[bytes[13]]}${byteToHex[bytes[14]]}${byteToHex[bytes[15]]}`;
  return postfix ? `${uuid.slice(0, -(postfix.length + 1))}-${postfix}` : uuid;
}
